import React from 'react';
import './Navbar.css'
import { Link } from 'react-router-dom';

let token = localStorage.getItem("token") ? localStorage.getItem("token") : null;

let data = token ?  JSON.parse(atob(token.split('.')[1])) : {}
const isAdmin = data.data?.role === 'admin';


const Navbar = () => {
    return (
        <>
        <div className='nav'>
<div className="ham-menu">
  <ul className="centre-text bold-text">
    {!isAdmin && <a href='/'>Home</a>}
    {data.data?.role === 'admin' ? <a href={`/termin`}> Rezervo </a> : data.data?.role === 'user' ? <a href={`/terminacc`}> Rezervo </a> : <a href='/termin'> Rezervo </a>}


    {data.data?.role === 'admin' ? <a href={`/termin/termin-calendar`}>Tabela e termineve</a> : ""}

    {token && !isAdmin ? <a href={`/auth/profile/${data.data._id}`}>Profile</a> : ""}
    {token ? <a href='/' onClick={()=> localStorage.removeItem("token")}>Log out</a> : <a href={`/auth/login`}>Log In</a>}


  </ul>
</div>
</div>
        </>
    )
}

export default Navbar
